/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_Load_ErrorInputs */

const en_mobile_player_load_error = /** @type {(inputs: Mobile_Player_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t load this audio. Check your connection and try again.`)
};

const es_mobile_player_load_error = /** @type {(inputs: Mobile_Player_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar este audio. Revisa tu conexión e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Couldn’t load this audio. Check your connection and try again." |
*
* @param {Mobile_Player_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_load_error = /** @type {((inputs?: Mobile_Player_Load_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_Load_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_load_error(inputs)
	return en_mobile_player_load_error(inputs)
});